import { getStoredItem } from '../../../stored-item'
import hash from '../../../hash'

const useUnveil = () => {
  const accessKey = getStoredItem('id5id', true) || process.env.RAZZLE_SPLUS_CONTENT_KEY

  const composerSpk = getStoredItem('spk', true)
  if (!accessKey || !composerSpk) {
    return false
  }

  const date = new Date()
  const spk = accessKey + date.getDay() + date.getHours()
  const spkCode = hash(spk)

  return String(spkCode) === String(composerSpk)
}

export default useUnveil
